// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import theme from './theme';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'; // Import all solid icons

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

library.add(fas);

root.render(
    <App />
);
